// extracted by mini-css-extract-plugin
export var brand = "_20-9";
export var compact = "_20-6";
export var extraSmall = "_20-7";
export var icon = "_20-0";
export var large = "_20-4";
export var light = "_20-1";
export var medium = "_20-5";
export var outline = "_20-b";
export var primaryDark = "_20-a";
export var primaryLight = "_20-8";
export var primaryModern = "_20-c";
export var success = "_20-2";
export var successSolid = "_20-3";